/* Blog landing pages (sections/jiec-blog-landing.liquid): filters, A to Z jumps, the Tiles / List switch and the closing card.
   Search and preview sheets come from jiec-field-and-lab.js. */
(function () {
  'use strict';

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function init(root) {
    if (root.__bl) return;
    root.__bl = true;

    var grid = root.querySelector('[data-bl-grid]');
    if (!grid) return;
    var slots = Array.prototype.slice.call(grid.querySelectorAll('.bl-slot'));
    var end = grid.querySelector('[data-bl-end]');
    var none = root.querySelector('[data-bl-none]');
    var bar = root.querySelector('[data-flab-bar]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-bl-filter]'));
    var current = 'all';

    function columns() {
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      return cols || 1;
    }

    // The closing card fills whatever is left of the last row, so no row ends with a gap.
    function fitEnd() {
      if (!end) return;
      var cols = columns();
      var shown = slots.filter(function (s) { return !s.hidden; }).length;
      var rem = shown % cols;
      var span = rem === 0 ? cols : cols - rem;
      end.style.gridColumn = 'span ' + span;
      end.classList.toggle('bl-end--narrow', span === 1 && cols > 1);
    }

    function applyFilter(f, fromUser) {
      current = f || 'all';
      var shown = 0;
      slots.forEach(function (s) {
        var on = current === 'all' || s.getAttribute('data-bl-group') === current;
        s.hidden = !on;
        if (on) shown += 1;
      });
      filters.forEach(function (b) {
        var on = b.getAttribute('data-bl-filter') === current;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (none) none.hidden = shown > 0;
      fitEnd();
      if (fromUser) {
        try {
          var u = new URL(location.href);
          if (current === 'all') u.searchParams.delete('show'); else u.searchParams.set('show', current);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
    }

    function scrollToEl(el) {
      var barH = bar ? bar.offsetHeight : 0;
      var top = el.getBoundingClientRect().top + window.pageYOffset - barH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    filters.forEach(function (b) {
      b.addEventListener('click', function () {
        applyFilter(b.getAttribute('data-bl-filter'), true);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-bl-jump]'), function (b) {
      b.addEventListener('click', function () {
        var l = b.getAttribute('data-bl-jump');
        var pick = function () { return slots.filter(function (s) { return !s.hidden && s.getAttribute('data-bl-letter') === l; })[0]; };
        var target = pick();
        if (!target) { applyFilter('all', true); target = pick(); }
        if (!target) return;
        scrollToEl(target);
        var link = target.querySelector('a');
        if (link) setTimeout(function () { link.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
      });
    });

    // Tiles / List switch. The choice is remembered on this device and can be linked with ?view=list.
    var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bl-view-btn]'));
    function setView(v, fromUser) {
      v = v === 'list' ? 'list' : 'grid';
      root.setAttribute('data-bl-view', v);
      viewBtns.forEach(function (b) {
        var on = b.getAttribute('data-bl-view-btn') === v;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      fitEnd();
      if (fromUser) {
        try { localStorage.setItem('jiec-bl-view', v); } catch (e) {}
        try {
          var u = new URL(location.href);
          if (v === 'grid') u.searchParams.delete('view'); else u.searchParams.set('view', v);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
    }
    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-bl-view-btn'), true); });
    });
    var view = null;
    try { view = new URL(location.href).searchParams.get('view'); } catch (e) {}
    if (!view) { try { view = localStorage.getItem('jiec-bl-view'); } catch (e) {} }
    setView(view, false);

    var start = 'all';
    try { start = new URL(location.href).searchParams.get('show') || 'all'; } catch (e) {}
    if (!filters.some(function (b) { return b.getAttribute('data-bl-filter') === start; })) start = 'all';
    applyFilter(start, false);

    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitEnd, 80); });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-bl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
